/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Terms_Button_NoteInputs */

const en_register_onboarding_terms_button_note = /** @type {(inputs: Register_Onboarding_Terms_Button_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The ‘Next’ button is only enabled after active consent.`)
};

const de_register_onboarding_terms_button_note = /** @type {(inputs: Register_Onboarding_Terms_Button_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der ‚Weiter‘-Button wird erst nach aktiver Zustimmung freigegeben.`)
};

/**
* | output |
* | --- |
* | "The ‘Next’ button is only enabled after active consent." |
*
* @param {Register_Onboarding_Terms_Button_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_terms_button_note = /** @type {((inputs?: Register_Onboarding_Terms_Button_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Terms_Button_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_terms_button_note(inputs)
	return en_register_onboarding_terms_button_note(inputs)
});